<template>
    <div class="landDetail">
        <leftnav class="fl" mkcode="A" :itemcode="yj_itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox py-4">
                        <div class="landThreadToggle-btn" v-if="matchDetail.pushStatus == 0"><el-button class="fr mr-4" :type="baseinfo.thread?'danger':'primary'" @click="landThreadToggle(baseinfo,'invest')">{{ baseinfo.thread?'移除':'加入' }}线索管理</el-button></div>
                    <div class="landThreadToggle-btn" v-else><el-button :disabled="true" class="fr mr-4" type="info">已推送单位：{{matchDetail.pushCompanyName}}</el-button></div>
                    <div class="bgwidth" style="height: auto; padding-bottom: 40px">
                        <table cellspacing="0" cellpadding="4" border="0" class="detail_table  margin-x-auto"
                            width="90%">
                            <tr v-show="pageType == 2">
                                <td class="thead font-bold" colspan="2">
                                    筛选条件
                                    <p class="mt-1"><i class="el-icon-star-on font-20" v-for="(item, index) in baseinfo.monitor.star" :key="index"></i></p>
                                </td>
                                <td class="thead" colspan="6">
                                    <div class="text-left rate-detail">
                                        <p :class="baseinfo.monitor.detail.amount?'font-bold':'gray-font'"><i class="el-icon-star-on font-20"></i> 投资金额高于最低监测标准；</p>
                                        <p :class="baseinfo.monitor.detail.keyword?'font-bold':'gray-font'"><i class="el-icon-star-on font-20"></i>  项目名称含重点行业关键词；</p>
                                        <p :class="baseinfo.monitor.detail.industry?'font-bold':'gray-font'"><i class="el-icon-star-on font-20"></i>  行业分类属于重点行业范围；</p>
                                        <p :class="baseinfo.monitor.detail.enterprise?'font-bold':'gray-font'"><i class="el-icon-star-on font-20"></i>  投资方属于重点企业；</p>
                                        <p :class="baseinfo.monitor.detail.city?'font-bold':'gray-font'"><i class="el-icon-star-on font-20"></i>  项目地点属于百城范围；</p>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="pageType == 3">
                                <td class="thead font-bold" colspan="2">线索分析</td>
                                <td class="thead" colspan="3">
                                    <div id="anlyse-charts"></div>
                                    <!-- <div class="text-left">
                                        <p>客户维度分析得分：{{ analyse.customer }}</p>
                                        <p>区域维度分析得分：{{ analyse.area }}</p>
                                        <p>行业维度分析得分：{{ analyse.industry }}</p>
                                        <p>规模维度分析得分：{{ analyse.scale }}</p>
                                        <p>总得分：{{ analyse.total }}</p>
                                        <p>评级：
                                            <span v-if="analyse.total >= 9">A+ - 特别关注</span>
                                            <span v-if="analyse.total >= 7.5 && analyse.total < 9">A - 重点关注</span>
                                            <span v-if="analyse.total >= 6 && analyse.total < 7.5">B - 中等关注</span>
                                            <span v-if="analyse.total >= 4 && analyse.total < 6">C - 简单关注</span>
                                            <span v-if="analyse.total < 4">D - 可以忽略</span>
                                        </p>
                                    </div> -->
                                </td>
                                <td class="thead">
                                     <div class="line-height36 font-bold">
                                        <p>总得分：{{ analyse.total }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                        <p>评级：
                                            <span v-if="analyse.total >= 9">A+ - 特别关注</span>
                                            <span v-if="analyse.total >= 7.5 && analyse.total < 9">A - 重点关注</span>
                                            <span v-if="analyse.total >= 6 && analyse.total < 7.5">B - 中等关注</span>
                                            <span v-if="analyse.total >= 4 && analyse.total < 6">C - 简单关注</span>
                                            <span v-if="analyse.total < 4">D - 可以忽略</span>
                                            <el-tooltip class="item smartTip-text" effect="light"
												placement="right-start">
												<i class="el-icon-question"
													style="color:cornflowerblue;margin-left: 5px;"></i>
												<div slot="content" class="list_tips">
                                                    <p class="list_tips_p">1-4分&nbsp;&nbsp;&nbsp;：D级，可以忽略</p>
                                                    <p class="list_tips_p">5-6分&nbsp;&nbsp;&nbsp;：C级，简单关注</p>
                                                    <p class="list_tips_p">7-8.5分：B级，中等关注</p>
                                                    <p class="list_tips_p">8.5-9分：A级，重点关注</p>
                                                    <p class="list_tips_p">9分以上：A+级，特别关注</p>
												</div>
											</el-tooltip>
                                        </p>
                                     </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="thead font-bold" colspan="7">公告详细信息</th>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公告标题:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.title }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目名称::</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectName }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">投资地点:</td>
                                <td class="col2" colspan="3">
                                    {{ baseinfo.investArea }}
                                </td>
                                <td class="col3 font-bold">投资模式:</td>
                                <td class="col4" colspan="2">{{ baseinfo.mode }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">投资金额:</td>
                                <td class="col2" colspan="3">{{ baseinfo.money }}</td>
                                <td class="col3 font-bold">投资时间:</td>
                                <td class="col4" colspan="2">{{ baseinfo.time }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">行业分类:</td>
                                <td class="cols3" colspan="3">{{ baseinfo.industry }}</td>
                                <td class="col1 font-bold">产业概念:</td>
                                <td class="cols3" colspan="2">{{ baseinfo.notion || '-' }}</td>

                            </tr>
                            <tr>
                                <td class="col1 font-bold">公司简称:</td>
                                <td class="col2" colspan="3">{{ baseinfo.shortName }}</td>
                                <td class="col1 font-bold">公司全称:</td>
                                <td class="col2" colspan="2">{{ baseinfo.companyName }}</td>
                            </tr>
                            <tr>
                                <td class="col3 font-bold">公司地点:</td>
                                <td class="col4" colspan="3">
                                    {{ baseinfo.companyArea }}
                                </td>
                                <td class="col1 font-bold">公司地址:</td>
                                <td class="col2" colspan="2">{{ baseinfo.companyAddress }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公司法人:</td>
                                <td class="col2" colspan="3">{{ baseinfo.legalPerson }}</td>
                                <td class="col3 font-bold">联系电话:</td>
                                <td class="col4" colspan="2">{{ baseinfo.phone }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目描述:</td>
                                <td class="col2" colspan="6">
                                    <div class="showLine-10 text-left">{{ baseinfo.summary }}</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">公告内容</td>
                                <td class="col2 investContent" colspan="6">
                                    <div class="text-left" :class="{ 'showLine-10': !isShowText }"
                                        v-html="baseinfo.content"></div>
                                    <el-divider><span class="curp" @click="isShowText = !isShowText">{{
                                        isShowText ? '收起' : '展开' }} <i
                                                class="el-icon-caret-bottom"></i></span></el-divider>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { name } from "echarts-extension-amap";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "landDetail",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(["isCollapse"]),
    },
    data() {
        return {
            userdata: {},
            yj_itemcode: "A",
            baseinfo: {
                monitor: {
                    star: 0,
                    detail: {
                        money: false,
                        keyword: false,
                        industry: false,
                        enterprise: true,
                        city: false,
                    }
                },
            },
            isShowText: false,
            pageType: 1,
            id: "",
            analyse: {},
            matchDetail: {},
            colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
        };
    },
    created() {
        this.pageType = this.$route.query.pageType ? this.$route.query.pageType : 1;
        this.id = this.$route.query.id;
        // if (this.pageType == 3) { 
            this.getAnalyseInfo();
        // }else{
            this.getDetail(); 
        // }
    },
    methods: {
        randerCharts(el,data) { 
            console.log('雷达图', data);
			var myChart = echarts.init(document.getElementById(el));
			var option = {
				title: {
					text: ''
				},
				color: this.colors,
				// legend: {
				// 	show: true, bottom: 0, left: 'center',
				// },
				tooltip: { show: true },
				radar: {
					// radius: 150,
					axisName: { fontSize: 14, color: '#666' },
					splitArea: {
						//分割区域的样式	
						areaStyle: { color: ['#fff', '#fff', '#fff', '#fff', '#fff'], opacity: 0.2, }
					},
					// splitLine:{lineStyle:{type:'dashed'}},
					axisLine: { show: true, color: "#eee" },  //设置所有刻度线不显示
					indicator: [{name:"客户维度", max: 10}, {name:"区域维度", max: 10}, {name:"行业维度", max: 10}, {name:"规模维度", max: 10}],
				},
				series: [{
					type: 'radar', label: { show: true },
					data:  [{value:[data.customer,data.area,data.industry,data.scale],name: '线索分析得分'}],
					areaStyle: { normal: { color: this.colors[0], opacity: 0.2, shadowColor: '#000', } },
					lineStyle: { normal: { color: 'blue', width: 2 } },//折线样式
					symbol: "none", // 去掉图表中各个图区域的边框线拐点
				}]
			};
			myChart.setOption(option);
		},
        //获取线索分析详情
        getAnalyseInfo() {
            this.bus.$emit('loading', true);
            this.$axios.get(this.$api.metall.investThread.Analyse() + '?id=' + this.id).then((res) => {
                if (res.data.success) {
                    this.analyse = res.data.data.analyse;
                    this.baseinfo = res.data.data.invest;
                    // this.matchDetail = res.data.data.invest;
                    document.title = this.baseinfo.projectName + '-详情页';
                    this.randerCharts('anlyse-charts',this.analyse);
                    this.bus.$emit('loading', false);
                } else {
                    //    this.$message.error(res.data.message); 
                    this.bus.$emit('loading', false);
                }
            })
        },
        getDetail() {
            this.bus.$emit('loading', true);
            this.$axios.get(this.$api.metall.investThread.Match() + '?id=' + this.id).then((res) => {
                if (res.data.success) {
                    console.log('res.data.detail', res);
                    this.baseinfo = res.data.data.land;
                    document.title= this.baseinfo.projectName + '-详情页';
                    this.matchDetail = res.data.data;
                    this.bus.$emit('loading', false);
                } else {
                    //    this.$message.error(res.data.message); 
                    this.bus.$emit('loading', false);
                }
            })
        },
    },
};
</script>
<style lang="scss">
.line-height36 {
    line-height: 36px;
}
#anlyse-charts {
    width: 600px;
    height: 300px;
    // border: 1px solid #eee;
}
.investContent {
    // line-height: 10px !important;

    p {
        /* 1. 确保是块级元素 */
        display: block;

        /* 2. 允许换行 */
        white-space: normal;

        /* 3. 处理长单词和URL */
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;

        /* 4. 防止宽度问题 */
        max-width: 100%;
        box-sizing: border-box;

        /* 5. 处理flex/grid布局 */
        min-width: 0;
        line-height: 40px;
    }

    .table-wrap {
        overflow: auto;
        table{
            td{
                max-width: fit-content !important;
                padding: 0;
                line-height: 10px;
            }
        }

        // /* 最简单：只修复第三列的换行问题 */
        // table tr td:nth-child(3) {
        //     word-break: break-word !important;
        //     word-wrap: break-word !important;
        //     max-width: 200px !important;
        //     /* 限制最大宽度 */
        //     overflow-wrap: break-word !important;
        //     white-space: normal !important;
        // }

        // /* 确保表格使用固定布局 */
        // table {
        //     table-layout: fixed !important;
        //     width: 100% !important;
        // }

        // /* 为所有列设置适当的宽度 */
        // table td {
        //     box-sizing: border-box !important;
        // }
    }
}

    .detail_table {
        border: 1px solid #f2f2f2;
        border-bottom: none;
        background: #fff;
        overflow: hidden;

        th,
        td {
            padding: 0 15px;
            text-align: center;
        }

        th {
            font-size: 16px;
            line-height: 54px;
            height: 54px;
            background: #f2f8fe;
            white-space: nowrap;
        }

        td {
            line-height: 24px;
            border-bottom: 1px solid #eee;
            min-width: 80px;
            font-size: 16px;
            text-align: center;
            padding-top: 8px;
            padding-bottom: 8px;
            max-width: 300px;
            border-right: 1px solid #eee;

            &.font-bold {
                font-size: 16px;
            }
        }

        tr:hover {
            background: #fcfdff;
        }

        a {
            color: #2a51a4;
        }

        tr td:first-child {
            background: #fcfdff;
        }

        a:hover {
            text-decoration: underline;
            color: #f39800;
        }

        &.table {
            border-top: 1px solid #f2f2f2;
            border-left: 1px solid #f2f2f2;
        }
    }

    .clueManagement .whitebox {
        min-height: 95vh;
    }

    .showLine-10 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }</style>